import { Icon, IconProps } from "@chakra-ui/react";

const ZoneArrow = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 22 22" {...props}>
      <path
        d="M15.0002 21.6669H7.00021V11.0002H0.546875L11.0002 0.546875L21.4535 11.0002H15.0002V21.6669Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default ZoneArrow;
